'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../dist-es6/client/formatters');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseRealtimeUpdateController=require('../../../../dist-es6/client/angularCommon/baseRealtimeUpdateController');
const{UpdateFailedError}=BaseRealtimeUpdateController;
const{SocketTimeoutError,UnexpectedError}=require('../../../../dist-es6/client/services/socketService');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const{HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');

const ControllerDefaults={
stateName:'fdc.features.forecast',
searchQuery:'',
maxSchedulesToDisplay:100,
selectedSchedule:null,
selectedAssessment:null,
preventRealtimeDigests:!0,
excludeLowFatigueHistory:!1,
hideSortPreference:!0};


const ForecastTopMargin=25;let

ForecastController=(_class=class ForecastController extends BaseRealtimeUpdateController{
constructor(
$scope,
$state,
$timeout,
$interval,
$element,
dateService,
breadcrumbsService,
forecastDataService,
userService,
Analytics,
uncaughtErrorHandler,
groupTreeService,
timeZoneService,
timeFormattingService,
paramSyncService,
displaySettingsService,
fatigueMeterTypeContentProviderService)
{
super(uncaughtErrorHandler,$scope,$timeout,$interval,dateService,timespan.fromMinutes(5),timespan.fromSeconds(1),timeZoneService);

const existingStickySettings={};

const showAlertingOnly=displaySettingsService.stickySettings.get('showAlertingOnly');
if(_.exists(showAlertingOnly)){
existingStickySettings.showAlertingOnly=showAlertingOnly;
}

const showActiveOnly=displaySettingsService.stickySettings.get('showActiveOnly');
if(_.exists(showActiveOnly)){
existingStickySettings.showActiveOnly=showActiveOnly;
}


this._$timeout=$timeout;
this._$state=$state;
this._$element=$element;

this._uncaughtErrorHandler=uncaughtErrorHandler;
this._forecastDataService=forecastDataService;
this._userService=userService;
this._analytics=Analytics;
this._timeFormattingService=timeFormattingService;
this._displaySettingsService=displaySettingsService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

this._timeZoneService=timeZoneService;
this.selectedSchedule=null;
this.selectedScheduleAlertInfo=null;

_.defaults(this,existingStickySettings,this._getFMTypeSpecificDefaults(),ControllerDefaults);

breadcrumbsService.startTrail(this._fatigueMeterTypeContentProviderService.forecastFeatureTitle);
groupTreeService.linkController(this);

this.sortOptions=[{
label:'Bucketed',
sortBy:_bucketedForecastSort},
{
label:'Assessment Status',
sortBy:_getCurrentStatusSortForAssessments({
getRange:()=>this.forecastRange,
isAlerting:p=>this._isAlerting(p,this.forecastRange)})},

{
label:'Aviation Status',
sortBy:_getCurrentStatusSortForAviation({
getRange:()=>this.forecastRange,
isAlerting:p=>this._isAlerting(p,this.forecastRange)})},

{
label:'Alert Start Time',
sortBy:_alertStartTimeSort},
{
label:'Future Alert Duration',
sortBy:_futureDurationSort},
{
label:'Total Alert Duration',
sortBy:_totalAlertDurationSort}];


if(this._isWFMA||this._isAFM){
this.visibleRangeOptions=[{
numHoursBefore:3,
numHoursTotal:12,
label:'12h'},
{
numHoursBefore:8,
numHoursTotal:24,
label:'1d'},
{
numHoursBefore:12,
numHoursTotal:48,
label:'2d'}];


this.selectedSortOption=this._isWFMA?
this.sortOptions.find(o=>o.label==='Assessment Status'):
this.sortOptions.find(o=>o.label==='Aviation Status');
}else{
this.visibleRangeOptions=[{
numHoursBefore:6,
numHoursTotal:20,
label:'20h'}];

this.timelineOptions={
timeAxis:{
scale:'hour',
step:2}};



this.selectedSortOption=this.sortOptions[0];
}

const label=this._displaySettingsService.stickySettings.get('selectedForecastVisibleRangeOptionLabel');
const stickyOption=_.find(this.visibleRangeOptions,{label});
this._setAndSaveSelectedVisibleRangeOption(_.exists(stickyOption)?stickyOption:_.last(this.visibleRangeOptions));

this._updateUrlParamsFromController=paramSyncService.start(this,$scope,newParams=>this._updateControllerParamsFromUrl(newParams));

if($state.params.groupId||$state.params.employeeId){
this._$timeout(()=>this._assignParamsToController($state.params));
}

this._$scope.$watch('controller.selectedSchedule',(newVal,oldVal)=>{
this._updateUrlParamsFromController({
personId:_.result(this.selectedSchedule,'id.toString')});


this.selectedAssessment=null;

if(!_.exists(this.selectedSchedule)){
this.sidebarVisible=!1;
return;
}

this.sidebarVisible=!0;
});

this.useFixedAxisPosition=!1;

this._onScrollHandler=(scope,{scrollTop}={})=>{
const useFixedAxisPosition=scrollTop>=ForecastTopMargin;

if(useFixedAxisPosition===this.useFixedAxisPosition){
return;
}

this._$scope.$evalAsync(()=>{
this.useFixedAxisPosition=useFixedAxisPosition;
});
};

const _debouncedCheckPartialGroupData=_.debounce(()=>{
const shouldReload=this.dataService.shouldReloadForLatestGroupData;
if(!_.exists(shouldReload)||!shouldReload){
return;
}

this.startNextUpdate();
},50);

this._$scope.$watch('controller.dataService.shouldReloadForLatestGroupData',()=>_debouncedCheckPartialGroupData());

this._$scope.$watchGroup([
'controller.selectedGroupData',
'controller.showAlertingOnly',
'controller.showActiveOnly',
'controller.selectedSortOption'],
()=>{

if(_.exists(this.showAlertingOnly)){
this._displaySettingsService.stickySettings.set('showAlertingOnly',this.showAlertingOnly);
}

if(_.exists(this.showActiveOnly)){
this._displaySettingsService.stickySettings.set('showActiveOnly',this.showActiveOnly);
}

_debouncedCheckPartialGroupData();

const persons=_.get(this,'selectedGroupData.aggregatePersons',[]);
if(!persons.length){
this.forecastSchedules=[];
this.selectedSchedule=null;
return;
}

this.forecastSchedules=this._filterAndSort(persons);
const selectedScheduleId=_.result(this.selectedSchedule,'id.toString',this._$state.params.personId);
const newSelectedScheduleWithSameId=selectedScheduleId&&this.forecastSchedules.find(s=>s.id.toString()===selectedScheduleId);

this._$scope.$evalAsync(()=>{
this.selectedSchedule=newSelectedScheduleWithSameId||null;

this._$timeout(()=>{

const scrollerElement=angular.element('.feature-main > .scroller-wrapper.forecast-schedules');
if(!scrollerElement){
return;
}

scrollerElement.triggerHandler('mouseenter');

if(!newSelectedScheduleWithSameId){
scrollerElement.scrollTop(0);
}
});
});
});

this._$scope.$watch('controller.searchQuery',_.debounce(()=>{

this._$timeout(()=>{
const scrollerElement=angular.element('.feature-main > .scroller-wrapper.forecast-schedules');
if(!scrollerElement){
return;
}

scrollerElement.triggerHandler('mouseenter');
scrollerElement.scrollTop(0);
});
},150));

this._$scope.$watch('controller.filteredSchedules',()=>{
if(!this.selectedSchedule){
return;
}

if(this.filteredSchedules&&this.filteredSchedules.length>0&&this.filteredSchedules.indexOf(this.selectedSchedule)!==-1){
return;
}

this._$scope.$evalAsync(()=>{
this.selectedSchedule=null;
});
});

this._beginUpdates();
}

_updateSelectedVisibleRangeOption(newOption){
this._setAndSaveSelectedVisibleRangeOption(newOption);
this.startNextUpdate();
}

_setAndSaveSelectedVisibleRangeOption(newOption){
this.selectedRangeOption=newOption;
this._displaySettingsService.stickySettings.set('selectedForecastVisibleRangeOptionLabel',this.selectedRangeOption.label);
}

_filterAndSort(persons){
let filteredPersons=_(persons);

if(this.showActiveOnly){
filteredPersons=filteredPersons.
filter(p=>this._isActive(p));
}

if(this.showAlertingOnly){
const intervalToConsiderAlerts=this._isWFMA?
this._forecastDataService.forecastRange:
TimeInterval.from(this._forecastDataService.currentTimeForForecast).to(this._forecastDataService.forecastRange.end);

filteredPersons=filteredPersons.filter(p=>this._isAlerting(p,intervalToConsiderAlerts));
}

return filteredPersons.
sortBy(this.selectedSortOption.sortBy).
value();
}

_isActive(p){
const _workedInLastSixHours=p.workdayStart!==null&&_.get(p,'forecast.schedule.duties',[]).some(d=>this._forecastDataService.forecastRange.intersects(d));

const isConsideredActive=this._isWFMA||this._isAFM?
_.exists(p.predictedWorkday):
_.result(p,'predictedWorkday.end.getTime',-1)>=this._forecastDataService.currentTimeForForecast.getTime();

return _workedInLastSixHours&&isConsideredActive;
}

_isAlerting(p,intervalToConsiderAlerts=TimeInterval.Forever){
const alertingIntervals=[].concat(
_.get(p,'visibleAlertRanges.past.Above',[]),
_.get(p,'visibleAlertRanges.future.Above',[]));


if(this._isWFMA){
_.pushMany(alertingIntervals,[].concat(
_.get(p,'visibleAlertRanges.past.At',[]),
_.get(p,'visibleAlertRanges.future.At',[]),
_.get(p,'assessments',[]).filter(a=>a.status==='Fail'||a.status==='Not Complete').map(a=>TimeInterval.fromPoint(a.time))));

}

if(alertingIntervals.length===0){
return!1;
}

const visibleAlertingIntervals=TimeInterval.clip(alertingIntervals).to(intervalToConsiderAlerts);

return visibleAlertingIntervals.length!==0;
}

_assignParamsToController(params){
if(this.forecastSchedules){
this.selectedSchedule=this.forecastSchedules.find(s=>s.id.toString()===params.personId);
}
this._groupTreeService.selectGroupWithId(params.groupId);
}

_updateControllerParamsFromUrl(newStateParams){
let{groupId,personId}=newStateParams;

if(_.get(this.selectedGroup,'id')===groupId&&
_.get(this.selectedSchedule,'id')===personId){
return;
}

this._assignParamsToController(newStateParams);
}

_getFMTypeSpecificDefaults(){
switch(_.get(this._userService,'currentUser.fatigueMeterType')){
case FatigueMeterType.WorkforceAviation:
return{
showAlertingOnly:!1,
showActiveOnly:!1};}



return{
showAlertingOnly:!0,
showActiveOnly:!0};

}

get use24HourTimeline(){
return this._timeFormattingService.safeUse24HourTimelineSetting;
}

get groupTreeService(){
return this._groupTreeService;
}

set groupTreeService(groupTreeService){
this._groupTreeService=groupTreeService;
}

get dataService(){
return this._forecastDataService;
}


async _update(){
try{
const{numHoursTotal,numHoursBefore}=this.selectedRangeOption;
await this.dataService.update({excludeLowFatigueHistory:this.excludeLowFatigueHistory,numHoursTotal,numHoursBefore});
}catch(err){
if(err instanceof SocketTimeoutError||err instanceof UnexpectedError){
throw new UpdateFailedError;
}
throw err;
}
}

get _isWFMA(){
return this._userService.currentUser.fatigueMeterType===FatigueMeterType.WorkforceAviation;
}

get _isAFM(){
return this._userService.currentUser.fatigueMeterType===FatigueMeterType.Aviation;
}

get $state(){
return this._$state;
}

get $scope(){
return this._$scope;
}

get _lastFetchTime(){
return this._forecastDataService.lastFetchTime;
}

get _isUpdating(){
return this._forecastDataService.isUpdating;
}

get groupTree(){
return this._forecastDataService.groupTree;
}

get estimatesAsOfTime(){
return this._forecastDataService.estimatesAsOfTime;
}

get selectedGroup(){
return this._groupTreeService.selectedGroup;
}

get selectedGroupData(){
return this._forecastDataService.selectedGroupData;
}

get currentTimeForForecast(){
return this._forecastDataService.currentTimeForForecast;
}

get forecastRange(){
return this._forecastDataService.forecastRange;
}

get localTimeZone(){
return this._timeZoneService.localTimeZone;
}},(_applyDecoratedDescriptor(_class.prototype,'_update',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_update'),_class.prototype)),_class);


const _sortUrgentToTop=p=>_.get(p,'currentAlertInfo.urgent',!1)?0:1;

const _getCombinedDurationFor=(person,prop)=>_.get(person,prop,[]).reduce((sum,ti)=>sum+=ti.duration.totalMilliseconds(),0);
const _sortTruncatedToBottom=p=>_.get(p,'timeOfLastPointBeforeTruncation',!1)?1:0;
const _isCurrentlyOnDuty=p=>_.get(p,'lastKnownStatus.onDuty')||_.get(p,'effectiveStatus.onDuty')?0:1;
const _isCurrentlyOnTrip=p=>_.get(p,'lastKnownStatus.onTrip')||_.get(p,'effectiveStatus.onTrip')?0:1;
const _hasAssessments=(p,getRange)=>_.get(p,'assessmentsInLast24Hours',[]).filter(a=>getRange().contains(a.time)).length!==0?0:1;
const _currentThresholdStatusSort=p=>{
switch(_.get(p,'currentStatus.thresholdStatus',ThresholdStatus.NotApplicable)){
case ThresholdStatus.Above:
return 0;
case ThresholdStatus.At:
return 1;
case ThresholdStatus.Below:
return 2;
default:
return 3;}
;
};

const _getFirstMatchingAssessmentTimeSort=(status,getRange)=>
p=>{
const matchingAssessments=_.get(p,'assessmentsInLast24Hours',[]).filter(a=>a.status===status&&getRange().contains(a.time));
const sortedAssessments=_.sortBy(matchingAssessments,a=>a.time.getTime());
return _.result(sortedAssessments,'[0].time.getTime',Infinity);
};

const _getFirstVisibleAlertStartTimeSorter=subType=>p=>_.result(p,`visibleAlertRanges.${subType}[0].start.getTime`,Infinity);

const _workdayBucketSort=p=>p.predictedWorkday?
p.predictedWorkday.contains(p.currentTimeForForecast)?
0:
1:
2;

const _nowOrFutureBucketer=(p,alertType,score,next)=>{
const firstStartTime=_.result(p,`visibleAlertRanges.future.${alertType}[0].start.getTime`);
if(_.exists(firstStartTime)){
if(firstStartTime===p.currentTimeForForecast.getTime()){
if(_.get(p,'lastKnownStatus.onDuty',_.get(p,'effectiveStatus.onDuty',!1))){
return score+0;
}
return score+1;
}
return score+2;
}
return next(p,score+3);
};

const _pastBucketer=(p,alertType,score,next)=>{
const firstStartTime=_.result(p,`visibleAlertRanges.past.${alertType}[0].start.getTime`);
if(_.exists(firstStartTime)){
return score+0;
}
return next(p,score+1);
};

const _timeAndTypeOfAlertBucketSort=p=>{
return _nowOrFutureBucketer(p,'Above',0,
(p,score)=>_nowOrFutureBucketer(p,'At',score,

(p,score)=>_pastBucketer(p,'Above',score,
(p,score)=>_pastBucketer(p,'At',score,

(p,score)=>score))));
};

const _bucketedForecastSort=[
_workdayBucketSort,
_timeAndTypeOfAlertBucketSort,
_sortTruncatedToBottom,
_getFirstVisibleAlertStartTimeSorter('future.Above'),
_getFirstVisibleAlertStartTimeSorter('past.Above'),
_getFirstVisibleAlertStartTimeSorter('future.At'),
_getFirstVisibleAlertStartTimeSorter('past.At'),
p=>_.result(p,'predictedWorkday.end.getTime',0)];


const _getCurrentStatusSortForAssessments=({getRange,isAlerting})=>[
_isCurrentlyOnDuty,
_currentThresholdStatusSort,


_workdayBucketSort,
_timeAndTypeOfAlertBucketSort,
_sortTruncatedToBottom,
_getFirstVisibleAlertStartTimeSorter('past.Above'),



p=>_getFirstMatchingAssessmentTimeSort('Fail',getRange),


_getFirstVisibleAlertStartTimeSorter('past.At'),
p=>_.result(p,'predictedWorkday.end.getTime',0),



p=>isAlerting(p)?0:1,
p=>_hasAssessments(p,getRange),
p=>_getFirstMatchingAssessmentTimeSort('Missed',getRange),
p=>_.result(p,'forecast.schedule.duties[0].start.getTime')];


const _getCurrentStatusSortForAviation=({getRange,isAlerting})=>[
_isCurrentlyOnDuty,
_isCurrentlyOnTrip,
p=>isAlerting(p)?0:1,
_currentThresholdStatusSort,
p=>_.result(p,'forecast.schedule.flights[0].start.getTime',_.result(p,'forecast.schedule.trips[0].start.getTime',[])),
..._bucketedForecastSort];


const _originalFinalSort=[
_sortTruncatedToBottom,

p=>{
const futureStatusStartTimes={
Above:_.result(p,'visibleAlertRanges.future.Above[0].start.getTime'),
At:_.result(p,'visibleAlertRanges.future.At[0].start.getTime'),
Below:_.result(p,'visibleAlertRanges.future.Below[0].start.getTime')};


if(!futureStatusStartTimes.Above&&!futureStatusStartTimes.At){
return Infinity;
}

return _.min([futureStatusStartTimes.Above,futureStatusStartTimes.At]);
},

_sortUrgentToTop,

_getFirstVisibleAlertStartTimeSorter('past.Above'),
_getFirstVisibleAlertStartTimeSorter('past.At'),

p=>_.result(p,'alertRanges.Above[0].start.getTime'),
p=>_.result(p,'alertRanges.At[0].start.getTime'),

_isCurrentlyOnDuty,

p=>_.result(p,'forecast.schedule.duties[0].start.getTime'),

p=>_.result(p,'visibleAlertRanges.past.Below[0].start.getTime')||_.result(p,'visibleAlertRanges.past.NotApplicable[0].start.getTime')];



const _alertStartTimeSort=[
_getFirstVisibleAlertStartTimeSorter('future.Above'),
..._originalFinalSort];


const _futureDurationSort=[
_sortUrgentToTop,
p=>-1*_getCombinedDurationFor(p,'visibleAlertRanges.future.Above'),
p=>-1*_getCombinedDurationFor(p,'visibleAlertRanges.future.At'),
..._originalFinalSort];


const _totalAlertDurationSort=[
_sortUrgentToTop,
p=>-1*(_getCombinedDurationFor(p,'visibleAlertRanges.future.Above')+_getCombinedDurationFor(p,'visibleAlertRanges.past.Above')),
p=>-1*(_getCombinedDurationFor(p,'visibleAlertRanges.future.At')+_getCombinedDurationFor(p,'visibleAlertRanges.past.At')),
..._originalFinalSort];


module.exports=ForecastController;
//# sourceMappingURL=forecastController.js.map
